export default {
  title: "Salesforce Chat",
  type: "rh/components/content/salesforce-chat",
  isContainer: false,
  config: {
    emptyLabel: "Salesforce Chat",
    isEmpty: () => false
  }
};
